import { ToggleButton } from "@mui/material";
import { ApplicationTooltip } from "../views";

type ModuleToggleButtonProps = {
    isActivated: boolean;
    setIsActivated: React.Dispatch<React.SetStateAction<boolean>>;
    tooltipTextWhenActivated: string;
    tooltipTextWhenDeactivated: string;
    children: React.ReactElement;
    disabled?: boolean;
};

export function ToolsPanelToggleButton({
    isActivated,
    setIsActivated,
    tooltipTextWhenActivated,
    tooltipTextWhenDeactivated,
    children,
    disabled = false,
}: ModuleToggleButtonProps) {
    return (
        <ApplicationTooltip
            disableInteractive
            title={
                isActivated
                    ? tooltipTextWhenActivated
                    : tooltipTextWhenDeactivated
            }
        >
            <ToggleButton
                value="check"
                selected={isActivated}
                onChange={() => setIsActivated(!isActivated)}
                sx={{
                    borderColor: "#9e9d9d",
                    '&.Mui-selected': {
                        backgroundColor: '#cdcdcd',
                    },
                    '&.Mui-selected.Mui-disabled': {
                        backgroundColor: 'transparent',
                        color: 'inherit',
                        borderColor: "#9e9d9d",
                    },
                    '&.Mui-disabled svg': {
                        color: 'rgba(0,0,0,0.26)'
                    },
                    height: '5px',
                    width: '5px',
                }}
                disabled={disabled}
            >
                {children}
            </ToggleButton>
        </ApplicationTooltip>
    )
}